import { useEffect, useMemo, useState } from "react";
import type { AboutContent } from "../../domain/entities/AboutContent";
import { AboutRepositoryImpl } from "../../infrastructure/repositories/AboutRepositoryImpl";
import { getAboutContent } from "../useCases/getAboutContent";

export const useAboutContent = () => {
  const [content, setContent] = useState<AboutContent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const repository = useMemo(() => new AboutRepositoryImpl(), []);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getAboutContent(repository);
        if (!cancelled) {
          setContent(data);
        }
      } catch (err: unknown) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : "Failed to load about content.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [repository]);

  return { content, loading, error };
};
